import { takeEvery, call } from 'redux-saga/effects';
import actionTypes from '../actionTypes';
import APIENDPOINTS from '../../constants/apiconstants';
import { saveData } from '../service/saveDataService';

function* saveEventTrackSaga(action) {
	const { portalUserContext, request } = action.payload;
	const url = `${APIENDPOINTS.EVENT_TRACK_URL}`;
	try {
		const eventResponse = yield call(
			saveData,
			request,
			url,
			portalUserContext.result,
			true
		);

		if (eventResponse.statusCode >= 400) {
			throw new Error(eventResponse?.statusCode);
		}
	} catch (error) {
		console.log(error);
	}
}

export function* eventTrackSagaWatcher() {
	yield takeEvery(actionTypes.SAVE_EVENT_TRACK_INFO, saveEventTrackSaga);
}
